module.exports = __webpack_public_path__ + "static/media/turn-back.61895cb7.png";